"use strict";
var _a, _b, _c, _d, _e, _f;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomersController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const customers_service_1 = require("./customers.service");
const jwt_auth_guard_1 = require("../../common/guards/jwt-auth.guard");
const permissions_guard_1 = require("../../common/guards/permissions.guard");
const permissions_decorator_1 = require("../../common/decorators/permissions.decorator");
const current_user_decorator_1 = require("../../common/decorators/current-user.decorator");
const user_entity_1 = require("../users/user.entity");
const permissions_1 = require("../authorization/permissions");
let CustomersController = class CustomersController {
    constructor(svc) {
        this.svc = svc;
    }
    search(q) {
        return this.svc.search(q || '');
    }
    findOne(id) {
        return this.svc.findById(id);
    }
    create(dto) {
        return this.svc.create(dto);
    }
    update(id, dto) {
        return this.svc.update(id, dto);
    }
    addAddress(id, dto) {
        return this.svc.addAddress(id, dto);
    }
    updateAddress(id, addressId, dto) {
        return this.svc.updateAddress(id, addressId, dto);
    }
    getLog(id) {
        return this.svc.getInteractionLog(id);
    }
    addLog(id, body, agent) {
        return this.svc.addLog(id, body.type, body.description, agent.id);
    }
};
exports.CustomersController = CustomersController;
tslib_1.__decorate([
    (0, common_1.Get)('search'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMERS_READ),
    tslib_1.__param(0, (0, common_1.Query)('q')),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "search", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMERS_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "findOne", null);
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMERS_CREATE),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_b = typeof Partial !== "undefined" && Partial) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "create", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMERS_UPDATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_c = typeof Partial !== "undefined" && Partial) === "function" ? _c : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "update", null);
tslib_1.__decorate([
    (0, common_1.Post)(':id/addresses'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMER_ADDRESSES_MANAGE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_d = typeof Partial !== "undefined" && Partial) === "function" ? _d : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "addAddress", null);
tslib_1.__decorate([
    (0, common_1.Patch)(':id/addresses/:addressId'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMER_ADDRESSES_MANAGE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Param)('addressId', common_1.ParseIntPipe)),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, typeof (_e = typeof Partial !== "undefined" && Partial) === "function" ? _e : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "updateAddress", null);
tslib_1.__decorate([
    (0, common_1.Get)(':id/interaction-log'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMER_INTERACTIONS_READ),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "getLog", null);
tslib_1.__decorate([
    (0, common_1.Post)(':id/log'),
    (0, permissions_decorator_1.RequirePermissions)(permissions_1.PERMISSIONS.CUSTOMER_INTERACTIONS_CREATE),
    tslib_1.__param(0, (0, common_1.Param)('id', common_1.ParseIntPipe)),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, current_user_decorator_1.CurrentUser)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object, typeof (_f = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _f : Object]),
    tslib_1.__metadata("design:returntype", void 0)
], CustomersController.prototype, "addLog", null);
exports.CustomersController = CustomersController = tslib_1.__decorate([
    (0, common_1.UseGuards)(jwt_auth_guard_1.JwtAuthGuard, permissions_guard_1.PermissionsGuard),
    (0, common_1.Controller)('customers'),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof customers_service_1.CustomersService !== "undefined" && customers_service_1.CustomersService) === "function" ? _a : Object])
], CustomersController);
